import React from 'react';
import styled from 'styled-components/macro';
import Rosco from './Rosco';
import { useTranslate } from '../contexts/languageContext';
import { addDot } from '../utils';
import { useIsDesktop, useIsMobile } from '../hooks/useMediaQuery';
import { responsive } from "../resources/constantes.json";

const ConsolidadoStats = props => {
  const t = useTranslate();
  const isDesktop = useIsDesktop();
  const isMobile = useIsMobile();
  const bigger = { fontSize: '3rem' };
  return (
    <SStatsContent isDesktop={isDesktop} isMobile={isMobile}>
      <p>{t('estadisticasPreconteo')}</p>
      <div>
        <Rosco
          porcAct={
            Number(props.data.pvot.act.slice(0, -1).replace(/,/g, '.')) / 100
          }
          porcAnt={
            Number(props.data.pvot.ant.slice(0, -1).replace(/,/g, '.')) / 100
          }
          porcAntant={
            Number(props.data.pvot.antant.slice(0, -1).replace(/,/g, '.')) / 100
          }
        />
        <Leyenda isDesktop={isDesktop}>
          <div>
            <BarraLeyenda color={tema.act} />
            <div>
              <div>2022</div>
              <div style={bigger}>{addDot(props.data.vot.act)}</div>
              <div>{props.data.pvot.act}</div>
            </div>
          </div>
          <div>
            <BarraLeyenda color={tema.ant} />
            <div>
              <div>2018</div>
              <div>{addDot(props.data.vot.ant)}</div>
              <div>{props.data.pvot.ant}</div>
            </div>
          </div>
          <div>
            <BarraLeyenda color={tema.antant} />
            <div>
              <div>2014</div>
              <div>{addDot(props.data.vot.antant)}</div>
              <div>{props.data.pvot.antant}</div>
            </div>
          </div>
        </Leyenda>
      </div>
    </SStatsContent>
  );
};

export default ConsolidadoStats;

const SStatsContent = styled.article`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  & p {
    padding: max(2%, 20px) max(10%, 20px);
  }

  & h3 {
    font-weight: bold;
    font-size: 1.6rem;
    text-transform: uppercase;
  }
  & > div {
    display: flex;
    ${({ isDesktop }) => !isDesktop && 'flex-direction: column;'};
  }
  & div svg {
    ${({ isDesktop }) => !isDesktop && 'width: 75%; margin: 0 auto'};
    ${({ isMobile }) => isMobile && 'height: auto'};
  }
`;

const Leyenda = styled.div`
  margin-left: 2em;
  margin-top: ${({ isDesktop }) => (isDesktop ? '2em' : '0')};
  color: #283f5f;
  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: ${({ isDesktop }) => (isDesktop ? '1.5em' : '0.5em')};

  @media (max-width: ${responsive.tablet}px) {
    flex-direction: row;
  }

  & h3 {
    font-size: 1.2rem;
    font-weight: 900;
    text-transform: uppercase;
  }
  & > div {
    display: flex;
    min-width: 48%;
  }
  & > div > div {
    display: flex;
    flex-direction: column;
  }
  & > div > div > div:first-child {
    font-size: 1.2rem;
    color: #222;
  }
  & div > div > div:nth-child(2) {
    font-size: 2rem;
    font-weight: bold;
  }
  & div > div > div:last-child {
    font-size: 1.6rem;
    font-weight: bold;
  }
`;

const tema = {
  act: '#00B0AC',
  ant: '#768AA4',
  antant: '#db979c',
};

const BarraLeyenda = styled.div`
  height: 6.2rem;
  width: 0;
  border-left: 5px solid ${props => props.color};
  border-right: 5px solid ${props => props.color};
  border-radius: 5px;
  margin-top: 0.6rem;
  margin-right: 1rem;
`;

const TitleConsolidado = styled.h3`
margin-top: 10px;
margin-left: 10px;
`;